export const accountTypes = [
    {
        accountType: 'Retirement',
        expandID: 'retirement',
        subText:
            'Prepare for the future with tax-advantaged investments intended for use later in life.',
        seeAllText: 'See All Retirement Accounts'
    },
    {
        accountType: 'General Investing',
        expandID: 'general-investing',
        subText:
            'Explore mutual funds developed with your investing goals in mind.',
        seeAllText: 'See All General Investing Accounts'
    },
    {
        accountType: 'College Savings',
        expandID: 'college-savings',
        subText:
            'Tax-advantaged way to save money for qualified education expenses in a professionally managed plan.'
    }
];

export const accountDetailsMap = {
    Retirement: [
        {
            header: 'Rollover IRA',
            description:
                'Convert assets from an old employer-sponsored plan into a Traditional IRA.',
            nasuURL:
                '/personal-investing/tools/nasu/mutual-fund/retirement/rollover'
        },
        {
            header: 'Traditional IRA',
            description: 'Potential upfront tax benefit.',
            nasuURL:
                '/personal-investing/tools/nasu/mutual-fund/retirement/contributory/traditional'
        },
        {
            header: 'Roth IRA',
            description: 'Potential delayed tax benefit.',
            nasuURL:
                '/personal-investing/tools/nasu/mutual-fund/retirement/contributory/roth'
        }
    ],
    'General Investing': [
        {
            header: 'Individual account',
            description:
                'Open a new mutual fund account with one registered owner to invest in mutual funds managed by T. Rowe Price',
            nasuURL:
                '/personal-investing/tools/nasu/mutual-fund/general-investing/individual'
        },
        {
            header: 'Joint account',
            description:
                'Open a new mutual fund account with multiple registered owners to invest in mutual funds managed by T. Rowe Price',
            nasuURL:
                '/personal-investing/tools/nasu/mutual-fund/general-investing/joint'
        },
        {
            header: 'Custodial account',
            description:
                "Make a gift or transfer assets to a child under a custodian's name.",
            nasuURL:
                '/personal-investing/tools/nasu/mutual-fund/general-investing/ugma-utma'
        },
        {
            header: 'Trust',
            description: 'Hold assets in the name of a trust.',
            nasuURL:
                '/personal-investing/tools/nasu/mutual-fund/general-investing/trust'
        }
    ],
    'College Savings': [
        {
            header: 'T. Rowe Price College Savings Plan',
            description:
                'This plan is sponsored by the state of Alaska, managed and marketed nationally by T. Rowe Price, and open to residents of any state.',
            nasuURL: 'https://www.troweprice529.com/enrollments/aknational'
        },
        {
            header: 'Maryland College Investment Plan',
            description:
                'This plan is sponsored by the state of Maryland and has state income tax and other benefits for Maryland residents.',
            nasuURL: 'https://maryland529.com/enrollments/mddirect'
        },
        {
            header: 'Alaska 529',
            description:
                'This plan is sponsored by the state of Alaska and has unique benefits for Alaskan residents. ',
            nasuURL: 'https://www.alaska529plan.com/enrollments/akdirect'
        }
    ]
};
